import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

import Head from "./Head";

const Header = () => {
  const [click, setClick] = useState(false);

  return (
    <>
      {/* Head */}
      {/* <section className="head">
        <div className="container flexSB">
          <div className="logo">
            <img
              src="/images/Asset7.png"
              alt="Academia Logo"
              className="logo-img"
            />
          </div>

          <div className="social">
            <i className="fab fa-facebook-f icon"></i>
            <i className="fab fa-instagram icon"></i>
            <i className="fab fa-twitter icon"></i>
            <i className="fab fa-youtube icon"></i>
          </div>
        </div>
      </section> */}
     <Head/>
      {/* Header */}
      <header>
        <nav className="flexSB">
          {/* <ul className={click ? "mobile-nav" : "flexSB "} onClick={() => setClick(false)}> */}
          <ul className={`${click ? "mobile-nav" : "flexSB"}`} onClick={() => setClick(false)}>

            {/* <li><Link to="/" >Inicio</Link></li>
            <li><Link to="/AboutUs">Quem Somos</Link></li>
            <li><Link to="/AboutUs">Sobre-nos</Link></li>
            <li><Link to="/ContactUs">Contacte-nos</Link></li>
            <li><Link to="/Downloads">Baixe Coisas</Link></li> */}
         <li><Link to="/">Início</Link></li>
          <li><Link to="/AboutUs">Quem Somos</Link></li>
          <li><Link to="/ContentPage">Conteúdo</Link></li>
          <li><Link to="/ContactUs">Contacte-nos</Link></li>
          <li><Link to="/Downloads">Baixe Coisas</Link></li>
          <li><Link to="/Jogos">Jogos</Link></li>
          </ul>

          <div className="start">
         <div><strong><p><Link to="/login" className="but">Iniciar Sessão</Link></p></strong> </div> 
          </div>

          <button className="toggle" onClick={() => setClick(!click)}>
            {click ? <i className='fa fa-times'> </i> : <i className='fa fa-bars'></i>}
          </button>
        </nav>
      </header>
    </>
  );
};

export default Header;

// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import './Header.css';

// const Header = () => {
//   const [click, setClick] = useState(false);

//   const handleToggle = () => {
//     setClick(!click);
//   };

//   return (
//     <>
//       {/* Head */}
//       <section className="head">
//         <div className="container flexSB">
//           <div className="logo">
//             <img
//               src="/images/Asset7.png"
//               alt="Academia Logo"
//               className="logo-img"
//             />
//           </div>

//           <div className="social">
//             <i className="fab fa-facebook-f icon"></i>
//             <i className="fab fa-instagram icon"></i>
//             <i className="fab fa-twitter icon"></i>
//             <i className="fab fa-youtube icon"></i>
//           </div>
//         </div>
//       </section>

//       {/* Header */}
//       <header>
//         <nav className="flexSB">
//           <ul className={click ? 'mobile-nav' : 'flexSB'} onClick={() => setClick(false)}>
//             <li><Link to="/">Inicio</Link></li>
//             <li><Link to="/AboutUs">Quem Somos</Link></li>
//             <li><Link to="/AboutUs">Sobre-nos</Link></li>
//             <li><Link to="/ContactUs">Contacte-nos</Link></li>
//             <li><Link to="/Downloads">Baixe Coisas</Link></li>
//           </ul>

//           <div className="start">
//             <div>
//               <strong>
//                 <p><Link to="/login" className="but">Iniciar Sessão</Link></p>
//               </strong>
//             </div>
//           </div>

//           <button className="toggle" onClick={handleToggle}>
//             {click ? <i className="fa fa-times"></i> : <i className="fa fa-bars"></i>}
//           </button>
//         </nav>
//       </header>
//     </>
//   );
// };

// export default Header;

